<template>
  <div>
    <a-button
      :icon="icon"
      @click="handleClick"
    >
      {{ buttonText }}
    </a-button>
    <a-modal
      :visible="visible"
      :title="title"
      :mask-closable="false"
      width="700px"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form
        class="form"
        :label-col="{ style: { minWidth: '115px' } }"
      >
        <slot />
      </a-form>
      <a-collapse
        :bordered="false"
      >
        <a-collapse-panel
          v-if="source"
          header="详细说明"
          style="border: 0"
        >
          <Markdown
            :source="source"
            :style="sourceStlye"
          />
        </a-collapse-panel>
      </a-collapse>
    </a-modal>
  </div>
</template>

<script>
import Markdown from '@/components/markdown';
export default {
  components: {
    Markdown,
  },
  props: {
    icon: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: 'Open Modal',
    },
    title: {
      type: String,
      default: 'Basic Modal',
    },
    source: {
      type: String,
      default: '',
    },
    sourceStlye: {
      type: Object,
      default: null,
    },
  },
  emits: ['click', 'save'],
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    handleClick() {
      this.visible = true;
      this.$emit('click');
    },
    handleOk() {
      this.$emit('save');
    },
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  margin-bottom: 20px;
}

:deep(.ant-collapse-item > .ant-collapse-header) {
  padding-left: 0;
}

:deep(.ant-collapse-item > .ant-collapse-header .ant-collapse-arrow) {
  left: 0;
}
</style>
